import { defineStore } from "pinia";
import { ref } from "vue";
import { useOfflineCompat } from "@/composables/useOfflineCompat";
import { useRest } from "@/composables/useRest";

export const useUfisStore = defineStore("ufis", () => {
  const ufis = ref([]);
  const ufisListLoad = ref(false);

  const offline = useOfflineCompat();
  const rest = useRest();

  async function setUfis(refresh = false) {
    try {
      let datos = [];
      if (ufisListLoad.value && !refresh) return;

      if (!refresh && offline.offlineServer) {
        let r = await offline.getList("ufis");
        if (Array.isArray(r.data.data) && r.data.data.length > 0 && r.data.data[0].list) {
          datos = r.data.data[0].list;
        }
      }

      if (!datos || refresh || datos.length < 1) {
        const url = `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/tipoufi/`;
        const r = await rest.get({ url });
        datos = r.data.data;
        offline.setList("ufis", datos);
      }
      ufis.value = datos;
      ufisListLoad.value = true;
    } catch (e) {
      console.error("setUfis>>", e);
    }
  }

  return {
    ufis,
    ufisListLoad,
    setUfis,
  };
});
